
import Card from 'vux/src/components/card/index.vue'


export default {
name: "resume",
components: {Card},
data() {
return {
name: this.$route.query.name,
list: [
{
name: '销售经理',
responsibilities: ['1、负责所管区域内公司产品行业需求调研、收集及整理；',
'2、负责所管区域内的渠道布局与拓展,完成销售区域内的销售任务；',
'3、负责所管区域内的渠道代理机构销售工作的管理与指导及关系维护；',
'4、负责所管区域内产品推广、最终用户公关及关系维护；',
'5、协助完成公司整体销售目标，完成领导交办的其他任务；'],
requirements: ['1、本科及以上学历，计算机、市场营销等相关专业者优先；',
'2、口齿清晰、善于表达，学习能力强，热爱营销工作；',
'3、具有IT分销经验及良好的用户关系者优先；',
'4、具有良好的协调、沟通能力，吃苦耐劳，具备团队协作精神，抗压能力强；']
},
{
name: '销售经理（OEM代工）',
responsibilities: ['1、面向行业目标客户ODM/OEM需求调研、收集及整理，发掘新客户；',
'2、根据客户需求制定相关代工方案&营销策略，完成合约的签订；',
'3、根据产品/项目情况，与客户及后台部门进行沟通交流，协同完成产品/项目交付；',
'4、大客户公关及关系维护；',
'5、完成事业部规定的销售目标和任务；',
'6、完成领导交办的其他任务；'],
requirements: ['1、大学本科学历，计算机、市场营销、供应链管理等相关专业；',
'2、熟悉供应链，对于生产运营管理有一定了解；',
'3、有工厂工作经验者优先，有客户资源者优先；',
'4、对计算机硬件（比如PC电脑、工作站、服务器、存储等产品）有一定了解；',
'5、口齿清晰、善于表达，学习能力强，热爱营销工作；',
'6、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力。']
},
{
name: 'C/C++软件开发工程师',
responsibilities: ['1.负责集群存储/分布式文件系统软件开发；',
'2.负责各操作系统下文件系统内核驱动软件开发；'],
requirements: ['1.统招本科以上学历，计算机，软件工程及相关专业;',
'2.优秀的计算机专业知识背景，扎实的数据结构、C/C++编程能力；',
'3.熟悉常用数据结构和常用算法；',
'4.熟练掌握并行处理和多线程开发技术；',
'5.熟悉Windows下的程序开发，熟悉MFC/QT/GTK一种或多种框架结构优先；',
'6.熟练使用Python语言，熟悉Linux操作系统优先；',
'7.了解分布式文件系统、高可用技术、数据维护管理等技术者优先；']
},
{
name: '软件开发工程师',
responsibilities: ['1、负责公司集群存储/分布式文件系统相关模块代码开发；'],
requirements: ['1、熟悉linux操作系统；',
'2、熟练掌握C语言、Shell/Perl/python其中一种或多种编程技术;',
'3、熟悉常用数据结构和常用算法；',
'4、熟悉常用文件系统(xfs/ext4)优先；',
'5、熟悉开源分布式存储系统(gluster/ceph)等相关知识优先；',
'6、熟悉一种操作系统（Win/Linux/OSX）内核开发技术优先；',
'7、有相关项目开发经验者优先；']
},
{
name: '硬件测试工程师',
responsibilities: ['1、负责产品硬件平台的测试和选型工作；',
'2、负责计算机硬件部件的评测工作；',
'3、负责跟进和解决生产环节出现的硬件问题；',
'4、负责完成产品硬件部件的测试报告；',
'5、负责各厂商来料变更的测试、封样及相关技术交涉工作；'],
requirements: ['1、计算机及电子相关专业，本科以上学历；',
'2、对计算机硬件有一定了解并具有浓厚兴趣；',
'3、有较强的自学能力；',
'4、做事严谨，责任心强，有团队意识；',
'5、有经验者优先；']
},
{
name: '装配工程师',
responsibilities: ['1、整机产品的软硬件装配；',
'2、对生产制程中遇到的问题进行总结和反馈，对不良品整机进行故障定位；',
'3、协助技术开发及质控部门完成现场质量及技术问题分析；',
'4、完成新产品在生产环节试制工作并提交报告，完成工程化相关文档的整理与修订；'],
requirements: ['1、计算机及电子相关专业，本科以上学历；',
'2、熟悉PC部件，对计算机硬件相关知识有深入了解；',
'3、具有较强的配合和沟能力，具有较强的责任心，能够承担工作压力；']
},
{
name: '结构工程师',
responsibilities: ['1、负责公司自有产品及ODM客户产品结构系统的研发设计工作,同时包括散热、噪声、包装等设计；',
'2、设计阶段进行装配设计缺陷评估，零件制造工艺评估，设计成本评估；',
'3、参与产品样机、小批量导入及验证；',
'4、负责产品结构异常处理及维护；',
'5、负责外协厂家加工工艺沟通及管理；',
'6、负责整理及编写相关技术文档；'],
requirements: ['1、本科及以上学历，机械、电子、模具设计师、自动化或计算机类相关专业；',
'2、熟练掌握proe、creo软件及autocad等软件；',
'3、熟悉机加工、钣金件，产品包装设计等加工工艺，熟悉阳极化、喷漆、丝印等各种表面处理工艺；',
'4、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；',
'5、具有广电类、服务器类产品腔体、机箱设计经验者优先考虑；']
},
{
name: '质量主管/经理',
responsibilities: ['1、负责建立、健全公司质量管理体系；',
'2、负责公司质量管理体系和产品的相关认证工作；',
'3、负责相关质量标准、质量纲要的制订；',
'4、负责对公司各部门工作、服务、产品质量定期和不定期执行监督检查和奖惩；',
'5、对供方实行品质管控，反馈相关质量数据，组织整改提升；',
'6、负责产品一次开箱合格率、返修率等质量指标的统计分析工作，并组织相关部门改进执',
'7、负责售后质量问题的受理、跟踪、协调、管理工作，从信息收集到问题解决全程负责；',
'8、负责重大质量问题的调查、跟踪处理及必要的现场支持工作；',
'9、其他质量相关工作；'],
requirements: ['1、计算机、统计学或同类专业，正规统招本科及以上学历；',
'2、熟悉掌握办公软件、Solidwirk等绘图软件的使用、具有一定的公文写作、数据分析能力；',
'3、熟悉质量体系（ISO9000/TS16949）及3c、节能等相关认证工作，有经验者优先；',
'4、熟知供应链生产管理体系；',
'5、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；']
},
{
name: '检验工程师',
responsibilities: ['1、负责公司所有产品（含三方产品）来料、生产、出入库前的检验与测试工作；',
'2、不良品部件及整机的故障定位及维修；',
'3、品质异常反馈及改善追踪、效果确认；',
'4、及时填写质量记录，分析并提交质量报表；',
'5、通过检验过程、记录，总结经验，寻求提升生产效率的方法；',
'6、完成领导交办的其他任务；'],
requirements: ['1、统招本科及以上学历，计算机、电子工程、自动化等相关专业；',
'2、熟悉生产制造，有两年以上QC相关工作经验；',
'3、熟悉服务器、非线性编辑工作站或有广电行业工作经验者优先；',
'4、具有良好的判断分析能力；',
'5、工作积极主动，具有较强的责任心、良好的沟通能力和团队协作能力；']
}, {
name: '前端开发工程师',
responsibilities: ['1、负责移动端H5和Web产品、推广活动等前端项目的开发和优化；',
'2、负责和后端工程师对接数据交互，能快速理解和消化各方需求并落实为具体工作；',
'3、对发现的产品Web前端缺陷能够快速、准确的定位，并妥善的解决；'],
requirements: ['1、统招本科以上学历，计算机，软件工程及相关专业；',
'2、精通HTML/XHTML、CSS等网页制作技术，熟悉页面架构和布局；',
'3、精通JavaScript、Ajax等Web开发技术；',
'4、熟悉 Vue/Angular框架并有实际工程经验者优先；',
'5、熟悉小程序、微信端应用开发；']
}
],
info: {}
}
},
methods: {
goToApply() {
this.$router.push({name: 'apply', query: {position: this.info.name}})
}
},
mounted() {
for (let i = 0; i < this.list.length; i++) {
if (this.name === this.list[i].name) {
this.info = this.list[i]
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/job/resume.vue